import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { MoreHorizontal, CreditCard, RefreshCcw, XCircle, Eye, Printer } from 'lucide-react';
import { CustomerCredit } from '@/hooks/useCustomerCredits';

interface CreditActionsDropdownProps {
  credit: CustomerCredit;
  onApply: () => void;
  onRefund: () => void;
  onCancel: () => void;
  onViewCreditNote?: () => void;
  onViewDetails?: () => void;
  
}

const CreditActionsDropdown: React.FC<CreditActionsDropdownProps> = ({
  credit,
  onApply,
  onRefund,
  onCancel,
  onViewCreditNote,
  onViewDetails,
}) => {
  const isActive = credit.status === 'issued' && credit.remaining_amount > 0;
  const hasCreditNote = !!credit.credit_note_number;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {/* View Details - always available */}
        {onViewDetails && (
          <DropdownMenuItem onClick={onViewDetails}>
            <Eye className="h-4 w-4 mr-2" />
            View Details
          </DropdownMenuItem>
        )}

        {/* View/Print Credit Note - available when credit note number exists */}
        {hasCreditNote && onViewCreditNote && (
          <DropdownMenuItem onClick={onViewCreditNote}>
            <Printer className="h-4 w-4 mr-2" />
            View/Print Credit Note
          </DropdownMenuItem>
        )}


        {/* Separator before action items */}
        {(onViewDetails || hasCreditNote) && isActive && (
          <DropdownMenuSeparator />
        )}

        {/* Credit Actions - only for active credits */}
        {isActive && (
          <>
            <DropdownMenuItem onClick={onApply}>
              <CreditCard className="h-4 w-4 mr-2" />
              Apply to Invoice
            </DropdownMenuItem>
            <DropdownMenuItem onClick={onRefund}>
              <RefreshCcw className="h-4 w-4 mr-2" />
              Refund Credit
            </DropdownMenuItem>
            <DropdownMenuItem onClick={onCancel} className="text-destructive">
              <XCircle className="h-4 w-4 mr-2" />
              Cancel Credit
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CreditActionsDropdown;